const ReformatEnv = (value: string) => value.trim().replace(/"/g, '').replace(/\/$/, '');

const API_BASE_URL = 'https://pbb-dashboard-api.investbamboo.dev';
const AUTH_MS_BASE_URL = 'https://auth-api.investbamboo.dev';
const SANDBOX_API_BASE_URL = 'https://pbb-dashboard-sandbox-api.investbamboo.dev';
const SANDBOX_AUTH_MS_BASE_URL = 'https://auth-sandbox.investbamboo.dev';
const APP_ENV = 'staging';
export const PRODUCTION_HOST = 'pbb.investbamboo.com';

export type AppMode = 'live' | 'sandbox';
export const MODE_STORAGE_KEY = 'pbb:environment';

// Live hosts come from the build; sandbox hosts are fixed and identical for every build.
export const environments = {
  live: {
    ApiBaseUrl: ReformatEnv(
      process.env.NEXT_PUBLIC_API_BASE_URL || process.env.NEXT_PUBLIC_API_URL || API_BASE_URL
    ),
    AuthMSBaseUrl: ReformatEnv(process.env.NEXT_PUBLIC_AUTH_MS_BASE_URL || AUTH_MS_BASE_URL)
  },
  sandbox: {
    ApiBaseUrl: SANDBOX_API_BASE_URL,
    AuthMSBaseUrl: SANDBOX_AUTH_MS_BASE_URL
  }
};

// Only the production frontend offers sandbox. Staging and local development are always live.
export function isProductionHost(): boolean {
  return typeof window !== 'undefined' && window.location.hostname === PRODUCTION_HOST;
}

function selectedMode(): AppMode {
  if (!isProductionHost()) return 'live';
  try {
    const saved = localStorage.getItem(MODE_STORAGE_KEY);
    if (saved === 'live' || saved === 'sandbox') return saved;
  } catch {
    // Session initialization reports unavailable browser storage.
  }
  return 'live';
}

const mode = selectedMode();
// Immutable for this page lifetime: changing mode must reload all clients and stores.
const AppConfig = Object.freeze({
  ...environments[mode],
  mode,
  environment: mode === 'sandbox' ? 'sandbox' : process.env.NEXT_PUBLIC_APP_ENV || APP_ENV,
  application: 'pbb' as const
});

export default AppConfig;
